var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-table",
        { attrs: { basic: "very", selectable: "", padded: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.tableColumns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.ticketList
            ? _c(
                "sui-table-body",
                _vm._l(_vm.ticketList, function (ticket, index) {
                  return _c(
                    "sui-table-row",
                    { key: index },
                    [
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c("sui-table-cell", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.getTicket(ticket.Id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(ticket.CaseNumber))]
                        ),
                      ]),
                      _c("sui-table-cell", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.getTicket(ticket.Id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(ticket.Subject))]
                        ),
                      ]),
                      _c("sui-table-cell", [_vm._v(_vm._s(ticket.Status))]),
                      _c("sui-table-cell", [
                        _vm._v(_vm._s(ticket.Category__c)),
                      ]),
                      _c("sui-table-cell", [_vm._v(_vm._s(ticket.Type))]),
                      _c("sui-table-cell", [_vm._v(_vm._s(ticket.Priority))]),
                      _c("sui-table-cell", [
                        _vm._v(_vm._s(_vm.toDateTime(ticket.CreatedDate))),
                      ]),
                      _c("sui-table-cell", [
                        _vm._v(_vm._s(_vm.toDateTime(ticket.ClosedDate))),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.ticketList.length === 0
        ? _c("div", { staticClass: "no-records-msg" }, [
            _c("p", [
              _vm._v(
                "No records to display. You haven't submitted any support tickets recently."
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }